import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie-consent')) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setVisible(false);
    // Disable GA by setting opt-out
    (window as any)['ga-disable-G-NQ8QGH30WE'] = true;
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        We use cookies for anonymous analytics to improve this tool.
        See our <a href="/privacy">Privacy Policy</a>.
      </p>
      <div className="cookie-buttons">
        <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>Accept</button>
        <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>Decline</button>
      </div>
    </div>
  );
}
